import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { User } from 'lucide-react';
import StudentPopup from './StudentPopup';
import './PartnersSection.css';

const PartnersSection: React.FC = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const clientCategories = [
    {
      title: 'IT Companies',
      description: 'Software development, cloud computing, cybersecurity firms',
      count: '25+'
    },
    {
      title: 'Banking & Finance',
      description: 'Banks, financial institutions, investment firms',
      count: '15+'
    },
    {
      title: 'Manufacturing',
      description: 'Engineering, automotive, pharmaceutical companies',
      count: '10+'
    }
  ];

  return (
    <section className="partners-section section">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Our Partners and Clients</h2>
          <p className="section-subtitle">
            Future Tech HR Services Private Limited - Trusted by leading organizations
          </p>
        </motion.div>

        <div className="partners-content">
          <motion.div
            className="client-categories"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <h3>Client Categories</h3>
            <div className="categories-grid">
              {clientCategories.map((category, index) => (
                <motion.div
                  key={category.title}
                  className="category-card"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  whileHover={{ y: -5 }}
                >
                  <div className="category-header">
                    <h4>{category.title}</h4>
                    <span className="category-count">{category.count}</span>
                  </div>
                  <p className="category-description">{category.description}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>

        <motion.div
          className="partners-cta"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          viewport={{ once: true }}
        >
          <div className="cta-content">
            <h3>Join Our Network of Success</h3>
            <p>
              Whether you're looking for top talent or seeking new opportunities, 
              we're here to connect you with the right match.
            </p>
            <div className="cta-buttons">
              <button 
                className="btn btn-primary"
                onClick={() => setIsPopupOpen(true)}
              >
                <User size={18} />
                Get Started
              </button>
            </div>
          </div>
        </motion.div>
      </div>
      
      <StudentPopup 
        isOpen={isPopupOpen} 
        onClose={() => setIsPopupOpen(false)} 
      />
    </section>
  );
};

export default PartnersSection;
